// extracted by mini-css-extract-plugin
export default {"imageWrapper":"yJ-z","twoColumnImage":"zJ-z"};